var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-right",class:{ 'hidden': _vm.hidden, selected: _vm.selectedMobileOption == 'overview' }},[_c('div',{staticClass:"viewer-action-details",attrs:{"id":"viewer-action-details"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }